export const ORGANIGRAMS_TAG_EVENTS = {
  CREATED_ORGANIGRAM: 'OrganigramAdded',
  DELETED_ORGANIGRAM: 'OrganigramDeleted',
};
